export default __webpack_public_path__ + "static/media/Central-de-Odontologia-Fisioterapia.36537e5d.png";